import { render, staticRenderFns } from "./finish_page_component.vue?vue&type=template&id=32fd079f&scoped=true&"
import script from "./finish_page_component.vue?vue&type=script&lang=js&"
export * from "./finish_page_component.vue?vue&type=script&lang=js&"
import style0 from "./finish_page_component.vue?vue&type=style&index=0&id=32fd079f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd079f",
  null
  
)

export default component.exports